import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import {
  AutomationsRequest,
  FieldConfig,
  MessagesRequest,
  ReserveWithGoogleRequest, TablesSettings
} from '@shared/restaurant/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class WhoService {
  private readonly baseUrl = '/v.1/who';

  constructor(private readonly http: ApiClientService) {
  }

  updateSquareOptions (options) {
    return this.http.post<any>('/v.1/who/squareoptions', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updateMessages (options: MessagesRequest) {
    return this.http.post<any>('/v.1/who/messages', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updateAutomations (options: AutomationsRequest) {
    return this.http.post<any>('/v.1/who/automations', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updateDisplayOptions (options) {
    return this.http.post<any>('/v.1/who/displayoptions', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updateDefaults (options) {
    return this.http.post<any>('/v.1/who/defaults', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updateReservationSettings (options) {
    return this.http.put<any>('/v.1/who/reservationSettings', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updatePublicWaitlist (options) {
    return this.http.post<any>('/v.1/who/publicWaitlist', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updatePublicApi (options) {
    return this.http.post<any>('/v.1/who/publicApi', options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  resetToDefaultPublicSettings () {
    return this.http.put<any>('/v.1/who/resetPublicWaitlist', {})
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  removePublicWaitlistImage (imageURL: string) {
    return this.http.post<any>('/v.1/who/removePublicWaitlistImage', { imageURL })
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  phoneVerification (formattedPhone) {
    return this.http.post<any>('/v.1/who/numVerification', formattedPhone)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  updateServiceSettings (options) {
    return this.http.put<any>('/v.1/who/serviceSettings', options);
  }

  updateResourceSettings (options) {
    return this.http.put<any>('/v.1/who/resourceSettings', options);
  }

  private responseHandler<T>(success, error, data: T): T {
    if (success) {
      return data;
    }

    throw Error(String(error));
  }

  reserveWithGoogle(data: ReserveWithGoogleRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/reserveWithGoogle`, data);
  }

  partyFields(data: FieldConfig[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/partyFields`, data);
  }

  tablesSettings(data: TablesSettings): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/tablesSettings`, data);
  }
}
